export enum AnchorHref {
  General = 'general',
  Roomtypes = 'roomtypes',
  Facilities = 'facilities',
  PracticalInfo = 'practical-info',
  SkiAncillaries = 'ski-ancillaries',
  Reviews = 'reviews',
  Destination = 'destination',
}
